import { ModalController } from '@ionic/angular';
import { NgxAuthService } from 'ngx-auth-utils';
import { firstValueFrom } from 'rxjs';
import { first } from 'rxjs/operators';
import { CostCenterSummary } from '@libs/core/api';
import { BillingInfoModalComponent } from '../components/billing-info-modal/billing-info-modal.component';
import { buildProjectBillingDetails } from './project-billing-details';

export async function presentBillingInfoModal(
  modalController: ModalController,
  authService: NgxAuthService,
  project: CostCenterSummary
): Promise<void> {
  const user = await firstValueFrom(authService.state.pipe(first()));
  const billingDetails = buildProjectBillingDetails(project, user ?? null);

  // When opening from inside another modal (e.g. quote detail),
  // Ionic behaves better if we set presentingElement to the current top modal.
  const topOverlay = await modalController.getTop();

  const modal = await modalController.create({
    component: BillingInfoModalComponent,
    componentProps: {
      billingDetails,
    },
    cssClass: 'billing-info-modal-shell',
    presentingElement: topOverlay ?? undefined,
  });

  await modal.present();
  await modal.onWillDismiss();
}
